import { render, staticRenderFns } from "./medicalHistory.vue?vue&type=template&id=1b0f4844&scoped=true"
import script from "./medicalHistory.vue?vue&type=script&lang=js"
export * from "./medicalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f4844",
  null
  
)

export default component.exports